export default __webpack_public_path__ + "static/media/Directors' Certificate to Ms Divinia A Segui ( Calamba Branch ).2df92662.pdf";